import Service from "./BaseService";

export interface iParts {
  className: string;
  typeOfBreakdown: string;
}
interface iCalculatePricePayload {
  markName: string; // "TOYOTA";
  modelName: string; // "Harrier XU10";
  buildYear: string; // "2023";
  importYear: string; // "2022";
  cabinNumber: string; // "";
  plateNumber: string; // "7310УАЕ";
  phone: string; // "89764949";
  firstName: string; // "Буднаран";
  register: string; // "RZ93898987";
  parts: iParts[]; // [{ className: "Крыло хойд"; typeOfBreakdown: "хагарсан" }];
}

export interface iCalculatePriceResponseData {
  model: string;
  market_price: string;
  spare_parts_price: number | null;
  repair_price: number | null;
  material_price: number | null;
  labor_fee: number | null;
  class_name: string;
  type_of_breakdown: string;
}

interface iCalculatePriceResponse {
  status: boolean;
  message: string;
  data: iCalculatePriceResponseData[];
}
const CalculatePrice = (payload: iCalculatePricePayload) =>
  Service.post("/v2/parts-calc", payload).then((response) =>
    Promise.resolve<iCalculatePriceResponse>(response)
  );

interface iCheckDataPayload {
  buildYear: string;
  modelName: string;
  markName: string;
  vin: string;
}

const CheckData = (payload: iCheckDataPayload) =>
  Service.post("/v2/check-data", payload).then((response) =>
    Promise.resolve<iCalculatePriceResponse>(response)
  );

const EstimationService = {
  CalculatePrice,
  CheckData,
};
export default EstimationService;
